import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

import { WebShopTypePicker, WebShopTypePickerProps } from './WebShopTypePicker';

interface Props extends Omit<WebShopTypePickerProps, 'multiple' | 'clearable'> {
  error?: string;
}

export const WebShopTypePickerField = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { t } = useTranslation();
    const { error, ...pickerProps } = props;
    const { value } = pickerProps;

    return (
      <EntityPickerPopover
        picker={<WebShopTypePicker {...pickerProps} clearable={false} />}
      >
        <PickerTargetButton
          ref={ref}
          label={t('COMMON.KIND')}
          error={error}
          value={value}
        />
      </EntityPickerPopover>
    );
  }
);
